
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

/**
 * Standardize DOMException availability. 
 * Most modern environments (Browsers & Node 20+) provide this natively.
 */
if (typeof window !== 'undefined' && typeof DOMException === 'undefined') {
  (window as any).DOMException = class extends Error {
    constructor(message: string, name: string = 'DOMException') {
      super(message);
      this.name = name;
    }
  };
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Initialization Failed: Root element not found.");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
